import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import DomainQueryScreenshot from '../assets/projects/domainquery/screenshot.webp';

const DomainQueryLanding = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a192f] via-[#112240] to-[#0a192f]">
      <Helmet>
        <title>DomainQuery</title>
      </Helmet>
      {/* Header */}
      <div className='w-full h=[80px] flex justify-between items-center px-4 py-2 text-gray-300'>
        <div>
          <Link to="/" className='text-4xl font-bold md:flex hover:text-blue-400 transition duration-300'>
            Ahnaf Mahmud
          </Link>
        </div>
      </div>
      
      {/* Main Content Section */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid md:grid-cols-2 gap-12 items-center min-h-[70vh]">
          {/* App Screenshot - Second on mobile, first on desktop */}
          <div className="flex justify-center order-last md:order-first">
            <img 
              src={DomainQueryScreenshot} 
              alt="DomainQuery App Screenshot" 
              className="rounded-3xl max-h-[650px] w-auto"
            />
          </div>

          {/* App Info - First on mobile, second on desktop */}
          <div className="space-y-8 order-first md:order-last">
            <div>
              <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
                Domain<span className="text-blue-500">Query</span>
              </h1>
              <p className="text-lg md:text-xl text-gray-300 mb-8">
                The ultimate domain lookup tool for your mobile device. Check DNS records and get RDAP & WHOIS info on the go.
              </p>
            </div>
            
            {/* Download Badges */}
            <div className="flex flex-row justify-center md:justify-start gap-4">
              <a href="https://apps.apple.com/app/domainquery/id6745438465" target="_blank" rel="noopener noreferrer" className="transition duration-300 transform hover:scale-105">
                <img 
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="Download on the App Store"
                  className="h-[57px] object-contain"
                />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.ip18.DomainQuery" target="_blank" rel="noopener noreferrer" className="transition duration-300 transform hover:scale-105">
                <img 
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                  alt="Get it on Google Play"
                  className="h-[80px] object-contain -mt-3"
                />
              </a>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-16 pt-8 border-t border-gray-700">
          <p className="text-gray-400">
            © 2025 Ahnaf Mahmud
          </p>
        </div>
      </div>
    </div>
  );
};

export default DomainQueryLanding;
